import "intersection-observer";
import "supplemental-prototype.mjs";

import React, { Fragment } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import App from "layout/App";
import ScrollToTop from "util/ScrollToTop";

import { theme, GlobalStyle } from "layout";
import { SiteSettingsProvider } from "./context/SiteSettingsContext/context";
import { AuthContextProvider } from "context/AuthContext";
import { VwoContextProvider } from "context/VwoContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const rootElement = document.getElementById("root");
const queryClient = new QueryClient();

const loadDOM = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <ScrollToTop>
        <SiteSettingsProvider>
          <AuthContextProvider>
            <VwoContextProvider>
              <ThemeProvider theme={theme}>
                <Fragment>
                  <App />
                  <GlobalStyle />
                </Fragment>
              </ThemeProvider>
            </VwoContextProvider>
          </AuthContextProvider>
        </SiteSettingsProvider>
      </ScrollToTop>
    </QueryClientProvider>
  </BrowserRouter>
);

const root = createRoot(rootElement);
root.render(loadDOM());
